<template>
  <b-container fluid id="form-container" ref="formContainer">
    <b-row>
      <b-col>
        <h2>Welcome and Onboarding Settings</h2>
        <p>These are application settings related to onboarding of new employees.</p>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <p class="h5 font-weight-bold mt-4">Welcome Email Message</p>
        <hr class="mt-0"/>
      </b-col>
    </b-row>
     <b-row>
        <b-col>
            <quill-editor
                ref="myQuillEditor"
                v-model="setting.value"
                :options="editorOptions"
            />
        </b-col>
    </b-row>

    <b-row class="mt-2 mb-4">
      <b-col>
         <b-button type="button" variant="primary" @click="saveSetting">Save Welcome Email Message</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <p class="h5 font-weight-bold mt-4">Welcome and Onboarding Documents</p>
        <hr class="mt-0"/>
         <b-button variant="primary" style="margin-bottom:20px;" size="sm" v-b-modal.modal-attachment>New Document</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
         <b-table hover small responsive show-empty
            id="qsDocument"
            :fields="fieldsDocument"
            :items="documents">
            <template v-slot:cell(actions)="row">
                <b-link :href="row.item.url" target="_qs">view</b-link>
                <b-button size="sm" class="ml-4" variant="link" @click="removeAttachment(row.index, row.item)">
                    <b-icon icon="x-circle-fill" aria-hidden="true"></b-icon>
                </b-button>
            </template>
            <template #table-caption></template>
            <template v-slot:empty="scope">
                <p>No documents found.</p>
            </template>
        </b-table>
      </b-col>
    </b-row>


    <b-row>
      <b-col>
        <p class="h5 font-weight-bold mt-4">Welcome and Onboarding Links</p>
        <hr class="mt-0"/>
         <b-button variant="primary" style="margin-bottom:20px;" size="sm" v-b-modal.modal-link>New Link</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
         <b-table hover small responsive show-empty
            id="qsLink"
            :fields="fieldsLink"
            :items="links">
            <template v-slot:cell(actions)="row">
                <b-link :href="row.item.url" target="_qs">view</b-link>
                <b-button size="sm" class="ml-4" variant="link" @click="removeLink(row.index, row.item)">
                    <b-icon icon="x-circle-fill" aria-hidden="true"></b-icon>
                </b-button>

            </template>
            <template v-slot:empty="scope">
                <p>No links found.</p>
            </template>
        </b-table>
      </b-col>
    </b-row>



    <b-modal  hide-footer
        id="modal-attachment"
        ref="modalDocument"
        title="Add Document"
        @show="resetModalDocument"
        @hidden="resetModalDocument"
        @ok="handleOkDocument">

        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group 
              label="Document Title" label-for="document-title-input" 
              invalid-feedback="Document Title is required">
              <b-form-input id="document-title-input" 
                v-model="$v.document.title.$model" 
                :state="$v.document.title.$dirty ? !$v.document.title.$error : null"
                aria-describedby="input-1-live-feedback"
                required>
              </b-form-input> 
              <b-form-invalid-feedback id="input-1-live-feedback">
                This is a required field and must have a length of 100 characters or less.
              </b-form-invalid-feedback>     
              <b-form-text id="name-input-help">Required.</b-form-text> 
            </b-form-group>

            <b-form-group :state="$v.document.file.$dirty ? !$v.document.file.$error : null"
                label="Document to Attach"
                label-for="file-input"
                invalid-feedback="Document Attachment is required">
                <b-form-file
                    id="file-input"
                    v-model="document.file"
                    :state="$v.document.file.$dirty ? !$v.document.file.$error : null"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here...">
                </b-form-file>
            </b-form-group>

            <b-button type="submit" variant="primary">Submit</b-button>
        </form>
    </b-modal>

    <b-modal  hide-footer
        id="modal-link"
        ref="modalLink"
        title="Add Link"
        @show="resetModalLink"
        @hidden="resetModalLink"
        @ok="handleOkLink">

        <form ref="form" @submit.stop.prevent="handleSubmitLink">
            <b-form-group 
              label="Link Title" label-for="link-title-input" 
              invalid-feedback="Link Title is required">
              <b-form-input id="link-title-input" 
                v-model="$v.link.title.$model" 
                :state="$v.link.title.$dirty ? !$v.link.title.$error : null"
                aria-describedby="input-1-live-feedback"
                required>
              </b-form-input> 
              <b-form-invalid-feedback id="input-1-live-feedback">
                This is a required field and must have a length of 100 characters or less.
              </b-form-invalid-feedback>     
              <b-form-text id="name-input-help">Required.</b-form-text> 
            </b-form-group>

            <b-form-group 
              label="Link URL" label-for="link-url-input" 
              invalid-feedback="Link URL is required">
              <b-form-input id="link-url-input" 
                v-model="$v.link.url.$model" 
                :state="$v.link.url.$dirty ? !$v.link.url.$error : null"
                aria-describedby="input-2-live-feedback"
                required>
              </b-form-input> 
              <b-form-invalid-feedback id="input-2-live-feedback">
                This is a required field and must have a length of 100 characters or less.
              </b-form-invalid-feedback>     
              <b-form-text id="name-input-help">Required.</b-form-text> 
            </b-form-group>

            <b-button type="submit" variant="primary">Submit</b-button>
        </form>
    </b-modal>

  </b-container>
</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric, url, requiredUnless, requiredIf } from 'vuelidate/lib/validators'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  data: () => ({

    documents: [],
    document: {
      title: '',
      file: null
    },

    links: [],
    link: {
      title: '',
      url: ''
    },

    fieldsDocument: [
      {key: 'attachmentTitle', sortable: true, label: 'Title'},
      {key: 'actions', label: 'Actions'}
    ],

    fieldsLink: [
      {key: 'linkTitle', sortable: true, label: 'Title'},
      {key: 'actions', label: 'Actions'}
    ],

    setting: { },
    editorOptions: {
        theme: 'snow',
        boundary: document.body,
        modules: {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'image', 'video']
        ]
        },
        placeholder: 'Insert text here ...',
        readOnly: false
    }
  }),

  components: {
    quillEditor
  },

  created() {
    this.loadSetting()
  },
  
  validations() {
    return {
      document: {
        title: { required },
        file: { required }
      },

      link: {
        title: { required },
        url: { required, url }
      },

    }
  },

  methods: {
    loadSetting() {
       axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/qs/attachments`)
        .then(response => { 
          this.documents = response.data
        })

       axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/qs/links`)
        .then(response => { 
          this.links = response.data
        })

        axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/setting/query`, {
          key: 'welcomeemail.text'
        })
          .then(response => { this.setting = response.data })

    },

    saveSetting() {
         axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/setting`, this.setting)
          .then(response => { this.setting = response.data })
    },
    
    handleSubmit() {
        this.$v.document.$touch()
        if (this.$v.document.$invalid) {
            return
        }
        
        const fd = new FormData()
        fd.append('file', this.document.file)
        fd.append('fileTitle', this.document.title)

        axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/qs/attachment`, fd, {params :{form: true}})
          .then(response => {
            this.document.file = null
            this.document.title = ''
            this.$v.document.$reset()
            this.documents = response.data
            this.$nextTick(() => {
              this.$bvModal.hide('modal-attachment')
            })
          })
    },

    handleSubmitLink() {
        this.$v.link.$touch()
        if (this.$v.link.$invalid) {
            return
        }
        
        let payload = {
          linkTitle: this.link.title,
          url: this.link.url
        }
        
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/qs/link`, payload)
          .then(response => {
            this.link.url = ''
            this.link.title = ''
            this.$v.link.$reset()
            this.links = response.data
            this.$nextTick(() => {
              this.$bvModal.hide('modal-link')
            })
          })
    },

    removeAttachment(idx, item) {
        axios.delete(`${process.env.VUE_APP_API_BASE_URL}/admin/qs/attachment/${item.id}`)
            .then(response => {
                this.documents = response.data
            })                
    },

    removeLink(idx, item) {
        axios.delete(`${process.env.VUE_APP_API_BASE_URL}/admin/qs/link/${item.id}`)
            .then(response => {
                this.links = response.data
            })                
    },

    resetModalDocument() {
      this.document.title = ''
      this.document.file = null
    },

    handleOkDocument(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },

    resetModalLink() {
      this.link.title = ''
      this.link.url = ''
    },

    handleOkLink(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmitLink()
    },

  }
}
</script>

<style>

</style>
